export default "__VITE_ASSET__Duwbu6qL__"